<template>
  <div class="home-page" style="padding-top: 0;">
		<div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="home-prize">
            <div class="home1">
                <div class="pt20">
                  <a class="logo" style="text-align: left;margin: 0 20px -80px;position: relative;" href="/"><img src="static/images/logo.png" /></a>
                </div>
              <img src="../../static/images/send.jpg" />
            </div>
          </div>
          <div class="input-div" style="margin-top: -100px;text-align: center">
            <div class="span mt30 fs33 fw7" style="font-weight: 400;margin-bottom: 15px;color: white">{{msg}}</div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="goLogin">{{$t('Subscribe')}}</button>
          </div>
<!--          <div class="ac otp-b disflex mt100">-->
<!--            <div style="color: white" class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>-->
<!--            <div style="color: white" class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>-->
<!--          </div>-->
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        msg:'',
      }
    },
    created(){
      if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
      if(this.$route.query.msg){
        this.msg = this.$route.query.msg
      }
    },
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      goLogin(){
        window.location.href = "http://he.snapai.asia/snapai/consent/page";
      }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/error.vue